export const Bio = {
  name: "Soumya Sourav Das",
  roles: [
    "ML Developer",
    "Python Programmer",
    "Data Science Geek",
    "Web Developer",
    "NLP and CV Geek",
  ],
  description:
    "B. Tech student at DTU with a strong programming background and a deep passion for Artificial Intelligence. Actively exploring Data Science, Machine Learning, Natural Language Processing, and Computer Vision to solve real-world problems through intelligent, data-driven solutions.",

  github: "https://github.com/celestial317/",
  resume:
    "https://drive.google.com/file/d/1tePgb-P0WfREcgDDi-9vgsz8rLwteaDY/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
  insta: "https://www.instagram.com/its_celestial_soumya/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Flask",
        image : "https://www.vectorlogo.zone/logos/palletsprojects_flask/palletsprojects_flask-ar21~v2.svg"  
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name : "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
      },
      {
        name: "Scikit Learn",
        image: "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg"
      },
      {
        name : "TensorFlow",
        image : "https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg"
      },
      {
        name : "OpenCV",
        image : "https://www.vectorlogo.zone/logos/opencv/opencv-ar21.svg"
      },
      {
        name : "Pandas",
        image : "https://cdn.worldvectorlogo.com/logos/pandas.svg"
      },
      {
        name : "Numpy",
        image : "https://www.vectorlogo.zone/logos/numpy/numpy-ar21.svg"
      },
      {
        name : "Matplotlib",
        image : "https://www.matplotlib.org/_static/logo2_compressed.svg"
      }
      
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Canva",
        image : "https://www.vectorlogo.zone/logos/canva/canva-ar21.svg"
      },
      {
        name: "Figma",
        image:
          "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",

      },
      {
        name: "C-language",
        image: "https://upload.wikimedia.org/wikipedia/commons/1/18/C_Programming_Language.svg"
      },
      {
        name: "Wordpress",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/98/WordPress_blue_logo.svg"
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
];

export const experiences = [
    {
    id: 0,
    img : "https://media.licdn.com/dms/image/v2/D560BAQFeolONERSpSg/company-logo_200_200/company-logo_200_200/0/1719491991499/inhouse_digitalproduction_logo?e=1758153600&v=beta&t=IJ4mtnOHipLQthV-wwhy-WpxyzaNQOVmDxuaEKe6-h8",
    role: "AIML Intern",
    company: "Inhouse Digital",
    date: "July 2025 - Present",
    skills: ["Agentic AI","Deep Learning","Neural Networks", "LangChain", "WebDev"]
  },
    {
    id: 1,
    img : "https://media.licdn.com/dms/image/v2/C4D0BAQGwhmO_u8_iyA/company-logo_200_200/company-logo_200_200/0/1657955301816/unominda_logo?e=1758153600&v=beta&t=w5CrN6hkol4DF0hr166Lwhyfixtrt5_uNCLiYiSGvOE",
    role: "Electrical Engineering Intern",
    company: "Uno Minda",
    date: "July 2025 - Aug 2025",
    skills: ["CAD","VLSI","PCB", "Circuit Design"]
  },
      {
    id: 2,
    img : "https://i.postimg.cc/Kz5psQNh/dtu.jpg",
    role: "Research Intern",
    company: "Under Prof Dhirendra Kumar",
    date: "July 2025 - Present",
    skills: ["CV","Deep Learning","Neural Networks", "Maths", "Computation"]
  },
  {
    id: 3,
    img : "https://winterofcode.tech/favicon.ico",
    role: "Open-Source Contributor",
    company: "Winter of Code",
    date: "Jan 2025 - Feb 2025",
    skills: ["Python","Deep Learning","Neural Networks", "TensorFlow", "RNN"]
  },
  {
    id: 4,
    img: "https://fresources.tech/images/fresourcesicon.svg",
    role: "Academic Manager",
    company: "Fresources.tech",
    date : "Sep 2024 - Present",
    skills: ["Team Management", "Analytical Skills", "Content Management", "Leadership", "Problem Solving"],
  },
];

export const education = [
  {
    id: 0,
    img: "https://i.postimg.cc/Kz5psQNh/dtu.jpg",
    school: "Delhi Technological University (DTU)",
    date: "July 2024 - Present",
    grade: "8.5/10 CGPA",
    desc: "I am pursuing a Bachelor's degree in Electrical Engineering at Delhi Technological University, where I am actively involved in the AI-ML society and Google Developers Student Club (GDSC). I have worked on exciting projects in Machine Learning, Cybersecurity, and Robotics alongside talented developers from the versatile background.",
    degree: "Bachelor of Technology - BTech, Electrical Engineering",
  },
  {
    id: 1,
    img: "https://i.postimg.cc/cCL0LF4d/dav.jpg",
    school: "DAV Centenary Public School, Narela, Delhi",
    date: "Apr 2021 - Mar 2023",
    grade: "93.80%",
    desc: "I completed my class 12 high school education at DAV Centenary School, Narela where I studied Science(Physics, Chemistry, Maths) with Computer Science and English.",
    degree: "CBSE XIIth, Science with Computer Sci.",
  },
  {
    id: 2,
    img: "https://i.postimg.cc/cCL0LF4d/dav.jpg",
    school: "DAV Centenary Public School, Narela, Delhi",
    date: "Apr 2018 - Mar 2021",
    grade: "91.80%",
    desc: "I completed my class 10 education at DAV Centenary School, Narela where I studied Science, Maths, SST, Sanskrit, English with Information Technology",
    degree: "CBSE Xth",
  },
];

export const projects = [
  {
    id: 0,
    title: "PsyAssist: Mental Health Chatbot",
    date: "March 2025",
    description:
      "PsyAssist is a multimodal, tonality-aware mental health chatbot that uses RAG to deliver empathetic, personalized support. Built with Flask, it features a clean UI and retrieves insights from a custom mental health knowledge base.",
    image: "https://i.postimg.cc/02ZzVxvt/psyassist.png",
    tags: ["Javascript", "ML", "NLP", "RAG"],
    category: "web app",
    github: "https://github.com/Celestial317/PsyAssist",
    webapp: "https://psyassist.onrender.com/",
    member: [
      {
        name: "Soumya Sourav Das",
        img: "https://i.postimg.cc/3NrFqTS3/ssd.jpg",
        linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
        github: "https://github.com/celestial317",
      },
      {
        name: "Shivaay Dhondiyal",
        img: "https://i.postimg.cc/0jJXnxbr/shivaay.jpg",
        linkedin: "https://www.linkedin.com/in/shivaay-dhondiyal/",
        github: "https://github.com/shivaay790",
      },
    ],
  },

  {
    id: 1,
    title: "Gesture Based Drone Control System",
    date: "January 2025",
    description:
      "Gesture Based Drone Control System is a proof-of-concept project that enables drone control through hand gestures and speech using ML and CV techniques. It features CNNs, MediaPipe, YOLO, and LLM-powered voice recognition for intuitive, remote-free operation.",
    image: "https://i.postimg.cc/FKrdZ8tb/676c564cadda6-optimized-1000.jpg",
    tags: ["Python","CNN", "ML", "CV", "Yolo"],
    category: "machine learning",
    github: "https://github.com/Celestial317/Gesture_Based_Drone_Control_System",
    webapp: "https://github.com/Celestial317/Gesture_Based_Drone_Control_System",
    member: [
      {
        name: "Soumya Sourav Das",
        img: "https://i.postimg.cc/3NrFqTS3/ssd.jpg",
        linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
        github: "https://github.com/celestial317",
      }
    ],
  },
  {
    id: 2,
    title: "Healthcare Guide System",
    date: "March 2025",
    description:
      "Pocket Guide to Health, Cure, and Cost. It is a location-based Android app delivering disease insights, nearby healthcare options, and estimated treatment costs. Powered by the Gemini API, it enables informed and accessible healthcare planning.",
    image: "https://i.postimg.cc/XYY6g6Nk/output-onlinepngtools.png",
    tags: ["GenAI", "Android App", "RAG"],
    category: "android app",
    github: "https://github.com/Celestial317/Healthcare_Guide_System",
    webapp: "https://github.com/Celestial317/Healthcare_Guide_System",
    member: [
      {
        name: "Soumya Sourav Das",
        img: "https://i.postimg.cc/3NrFqTS3/ssd.jpg",
        linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
        github: "https://github.com/celestial317",
      },
      {
        name: "Himanshu Mourya",
        img: "https://i.postimg.cc/tT82Yf2b/himanshu.jpg",
        linkedin: "https://www.linkedin.com/in/himanshu-mourya-77136828a/",
        github: "https://github.com/HIMANSHUMOURYADTU"
      },
      {
        name: "Aryan Baglane",
        img: "https://i.postimg.cc/MZsL8Py9/aryan-baglane.jpg",
        linkedin: "https://www.linkedin.com/in/aryan-baglane-89433a264/",
        github: "https://github.com/Aryan-Baglane"
      },
      {
        name: "Anugya Saxena",
        img: "https://i.postimg.cc/TYNhg6nn/anugya.jpg",
        linkedin: "https://www.linkedin.com/in/anugya-saxena-39aa571a8/",
        github: "https://github.com/Anugya-algo"
      }
    ],
  },
  {
    id: 3,
    title: "Multi-Agent Truth Verification Framework using LangChain",
    date: "May 2025",
    description:
      "A modular, multi-agent system built with the LangChain framework that verifies user claims and responses by delegating tasks to specialized agents. It cross-validates answers using tools like Wikipedia, DuckDuckGo, and math/logic solvers, ensuring factual, grammatical, and contextual correctness across domains such as language, coding, mathematics, and general knowledge. Designed for trust, transparency, and precision.",
    image: "https://i.postimg.cc/x126d5rV/Screenshot-2025-05-15-032618.png",
    tags: ["Python", "LangChain", "ML", "LLM", "Agentic AI"],
    category: "machine learning",
    github: "https://github.com/Celestial317/proof-check-agent",
    webapp: "https://github.com/Celestial317/proof-check-agent",
    member: [
      {
        name: "Soumya Sourav Das",
        img: "https://i.postimg.cc/3NrFqTS3/ssd.jpg",
        linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
        github: "https://github.com/celestial317",
      }
    ],
  },
  {
    id: 4,
    title: "Query Agent Based on Knowledge RAG",
    date: "May 2025",
    description:
      "A Retrieval-Augmented Generation (RAG) system enhanced with a Query Agent that intelligently routes user queries to the most suitable knowledge source—arXiv, Wikipedia, or Tavily—for contextually accurate and up-to-date responses.",
    image: "https://i.postimg.cc/FzyW5cXC/Screenshot-2025-05-17-152639.png",
    tags: ["Python", "LangChain", "ML", "LLM", "RAG"],
    category: "machine learning",
    github: "https://github.com/Celestial317/agentic-knowledge-rag",
    webapp: "https://github.com/Celestial317/agentic-knowledge-rag",
    member: [
      {
        name: "Soumya Sourav Das",
        img: "https://i.postimg.cc/3NrFqTS3/ssd.jpg",
        linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
        github: "https://github.com/celestial317",
      }
    ],
  },
  {
    id: 5,
    title: "EcoScan: AI App for Sustainability",
    date: "June 2025",
    description:
      "EcoScan is an AI-driven product scanning app that helps consumers make eco-conscious choices. Developed for the IBM Hackathon, it utilizes RAG and VLMs to analyze product compositions, assess environmental impact scores, and suggest sustainable alternatives. Users can track their streaks to build long-term eco-friendly habits, while the financial model supports ethical brands and responsible consumption.",
    image: "https://i.postimg.cc/qqxchPz1/Screenshot-2025-06-10-173400.png",
    tags: ["Kotlin", "Android App", "RAG", "VLM"],
    category: "android app",
    github: "https://github.com/Celestial317/EcoScanApp",
    webapp: "https://github.com/Celestial317/EcoScanApp",
    member: [
      {
        name: "Soumya Sourav Das",
        img: "https://i.postimg.cc/3NrFqTS3/ssd.jpg",
        linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
        github: "https://github.com/celestial317",
      },
      {
        name: "Aryan Baglane",
        img: "https://i.postimg.cc/MZsL8Py9/aryan-baglane.jpg",
        linkedin: "https://www.linkedin.com/in/aryan-baglane-89433a264/",
        github: "https://github.com/Aryan-Baglane"
      },
      {
        name: "Devyanshi Bansal",
        img: "https://i.postimg.cc/7Y5VHZ4L/devyanshi-bansal.jpg",
        linkedin: "https://www.linkedin.com/in/devyanshi-bansal/",
        github: "https://github.com/DevyanshiBansal",
      },
      {
        name: "Sudhanshu Shekhar",
        img: "https://i.postimg.cc/CMX84HyF/sudhanshu-shekhar.jpg",
        linkedin: "https://www.linkedin.com/in/sudhanshu-shekhar-a341921b6/",
        github: "https://github.com/Sudhanshu727",
      },
      {
        name: "Taher Merchant",
        img: "https://i.postimg.cc/W1P9bq77/taher-merchant.jpg",
        linkedin: "https://www.linkedin.com/in/taher-merchant-726757278/",
        github: "https://github.com/TaherMerchant25",
      }
    ],
  },
  {
    id: 6,
    title: "Automated Code Correction Agentic System",
    date: "May 2025",
    description:
      "An AI-powered debugging tool that analyzes, corrects, and optimizes code using agentic AI models. It detects errors, suggests improvements, and adapts to different languages and coding styles. Future integration as a code editor extension will enable seamless real-time corrections.",
    image: "https://i.postimg.cc/Znx1JPyX/Screenshot-2025-06-10-173507.png",
    tags: ["Python", "LangChain", "ML", "Agentic AI"],
    category: "machine learning",
    github: "https://github.com/Celestial317/automated-code-correction",
    webapp: "https://github.com/Celestial317/automated-code-correction",
    member: [
      {
        name: "Soumya Sourav Das",
        img: "https://i.postimg.cc/3NrFqTS3/ssd.jpg",
        linkedin: "https://www.linkedin.com/in/soumyasouravdas/",
        github: "https://github.com/celestial317",
      }
    ],
  },

];
